export interface ErrorDTO {
  HTTPStatus: string;
  Code: string;
  Message: string;
}
